module.exports = __webpack_public_path__ + "static/media/zephyr.5f9848fd.png";